module.exports = __webpack_public_path__ + "img/GH-kyujin-top-004.ab65999c.webp";